const isCurrentSystem = (name: string): boolean => {
  if (process.env.NODE_ENV === "development") {
    return true;
  } else {
    if (name == "all") {
      if (document.domain.indexOf(process.env.VUE_APP_SAAS_SYSTEM) == -1) {
        return false;
      } else {
        return true;
      }
    } else {
      return name == process.env.VUE_APP_SAAS_SYSTEM;
    }
  }
};

export { isCurrentSystem };
